import React from 'react'
import PropTypes from 'prop-types'

const AttachmentImage = ({ image, onImageClick, index }) => (
  <div className="section__item section__item--image">
    <a href={image.attributes.url} download={image.attributes.filename} className="item-info">
      <div className="item-info__title">
        <b>{image.attributes.fileName}</b>
      </div>
      <div className="item-info__date">{image.uploadDate}</div>
    </a>
    <div className="item-image">
      <img src={image.attributes.url} onClick={(e) => onImageClick(index, e)} />
    </div>
  </div>
)

AttachmentImage.propTypes = {
  image: PropTypes.shape({
    attributes: PropTypes.shape({
      url: PropTypes.string.isRequired,
      fileName: PropTypes.string.isRequired,
      uploadDate: PropTypes.string.isRequired,
    }),
  }).isRequired,
  onImageClick: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired,
}

export default AttachmentImage
